import { eOptionLayout } from "@models";
import { Utils } from "@tools";

export interface IImageSelectHelperScope extends ng.IScope{
    optionLayout?: string;
}

export class ImageSelectHelper {
    constructor(
        private $window: ng.IWindowService,
        private $timeout: ng.ITimeoutService,
        private scope: IImageSelectHelperScope,
        private element: JQuery
    ) {
        
        let windowResize = Utils.debounce(() => {
            //if we are in a mode of scroll, then we need to find a margin between items that leaves an option
            //halfway out of view to be clear there are more items to scroll horizontally to.

            if (scope.optionLayout == eOptionLayout.scroll) {

                //make sure there are enough items to scroll
                let minMargin = 4;
                let play = .05;
                let minPlayRange = .5 - play;
                let maxPlayRange = .5 + play;
                let $items = element.find(".kb-option");
                let $firstItem = $items.length ? $items[0] : null;
                if ($firstItem) {
                    let itemWidth = $firstItem.offsetWidth;
                    let itemAndMargin = itemWidth + minMargin;
                    let elWidth = element.innerWidth();

                    //make sure there are enough items that we should be scrolling
                    if (elWidth < (itemAndMargin * $items.length)) {
                        //find the number of visible items with min margin
                        let n = elWidth / itemAndMargin;
                        //now round up to the nearest half
                        let remainder = n % 1;
                        if (remainder < minPlayRange || remainder > maxPlayRange) {
                            let nModifier = remainder < minPlayRange ? -remainder - .5 : .5 - remainder;
                            let idealN = n + nModifier;
                            let idealMargin = (elWidth - (itemWidth * idealN)) / (idealN - .5);
                            $items.css("margin-right", idealMargin);
                        } else {
                            //do nothing... we are close enough
                            $items.css("margin-right", minMargin);
                        }
                    }
                }
            }
        }, 100);

        $($window).on("resize", windowResize);
        $timeout(() => {
            windowResize();
        }, 0);

        scope.$watch("optionLayout", (newVal, oldVal) => {
            element.removeClass("kb-image-select--" + (oldVal || eOptionLayout.wrap));
            element.addClass("kb-image-select--" + (newVal || eOptionLayout.wrap));
            windowResize();
        });

        scope.$on("$destroy", () => {
            element.off();
            $($window).off("resize", windowResize);
        });
    }
}
